import { useEffect, useRef } from 'react';
import { toasterApi } from '@terra/ui-design-system';
import { shouldContinueHarFilterPaging } from '../utils/reassociate-har-entries/range-select-ids';

type HarListFetchError = {
  message: string;
};

type UseHarFilterAutoPageArgs = {
  hasActiveFilters: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  loadedCount: number;
  error: HarListFetchError | null;
  fetchNextPage: () => void;
  errorTitle: string;
};

export function useHarFilterAutoPage({
  hasActiveFilters,
  hasNextPage,
  isFetchingNextPage,
  loadedCount,
  error,
  fetchNextPage,
  errorTitle,
}: UseHarFilterAutoPageArgs): void {
  const toastedHarListErrorRef = useRef<string | null>(null);

  useEffect(() => {
    if (
      !shouldContinueHarFilterPaging({
        hasActiveFilters,
        hasNextPage,
        isFetchingNextPage,
        loadedCount,
        hasFetchError: Boolean(error),
      })
    ) {
      return;
    }

    void fetchNextPage();
  }, [
    error,
    fetchNextPage,
    hasActiveFilters,
    hasNextPage,
    isFetchingNextPage,
    loadedCount,
  ]);

  useEffect(() => {
    if (!error || loadedCount === 0) {
      if (!error) {
        toastedHarListErrorRef.current = null;
      }

      return;
    }

    if (toastedHarListErrorRef.current === error.message) {
      return;
    }

    toastedHarListErrorRef.current = error.message;
    toasterApi.error({
      title: errorTitle,
      description: error.message,
    });
  }, [error, errorTitle, loadedCount]);
}
